import { useTranslator } from "@eo-locale/react";

import { Box, Button } from "@/storybook-components";

interface IFilterButton {
  handleFilterClick: () => void;
}

const AccessibilityButton = ({ handleFilterClick }: IFilterButton) => {
  const { translate } = useTranslator();
  // eslint-disable-next-line no-undef
  const keyboardKey = navigator.userAgent.includes("Macintosh") ? (
    <>⌘ + k</>
  ) : (
    <>⎇ + k</>
  );
  return (
    <Box display={{ base: "auto", lg: "flex", sm: "none" }}>
      <Button
        size="md"
        boxShadow="md"
        variant="secondary"
        onClick={handleFilterClick}
        aria-label={translate("places.keyboard.keyboardShortcut")}
        border={"none"}
      >
        {keyboardKey}
      </Button>
    </Box>
  );
};

export default AccessibilityButton;
